// İt257 (2026-05-22) — Karargah onaylı küresel "Başa Dön" butonu.
// Sayfa 300px aşağıda görünür hale gelir; tıklama smooth scroll to top.
// Tüm uygulamada Layout.jsx içinden tek seferde aktif (her sayfa yararlanır).
import React, { useEffect, useState, useCallback } from 'react';
import { ChevronUp } from 'lucide-react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };
    // Pasif listener — scroll performansını bozmasın
    window.addEventListener('scroll', onScroll, { passive: true });
    // Mount anında bir kez kontrol et (refresh sonrası ortada açılırsa)
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = useCallback(() => {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (_) {
      // Eski WebView (Zebra KitKat) smooth desteklemez → fallback hard set
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Başa Dön"
      title="Başa Dön"
      className={`fixed bottom-8 right-8 z-50 bg-blue-600 text-white rounded-full p-3 shadow-lg hover:bg-blue-700 transition-all ${
        visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}
    >
      <ChevronUp className="w-5 h-5" />
    </button>
  );
}
